import isElectron from 'is-electron'
import isWindows from 'is-windows'
import React from 'react';
import ReactTooltip from 'react-tooltip'
import classnames from 'classnames'

import KBoardListener from './components/device/KBoardListener'
import EditorHeader from './components/EditorHeader'
import EditorBody from './components/EditorBody'
import EditorFooter from './components/EditorFooter'
import Preferences from './components/Preferences'

function Editor() {
  return (
    <div className={
      classnames(
        'editor',
        {'electron': isElectron()},
        {'windows': isElectron() ? isWindows() : window.navigator.platform.includes('Win')}
      )
    }>
      <KBoardListener />
      <EditorHeader />
      <EditorBody />
      <EditorFooter />
      <Preferences />
      <ReactTooltip
        place="bottom"
        type="dark"
        effect="solid"
        clickable={true}
      />
    </div>
  );
}

export default Editor;
